import { useState } from 'react';
import QuickEntryFormModal from '@/components/feature/QuickEntryFormModal';

export default function CtaBanner() {
  const [cooperationOpen, setCooperationOpen] = useState(false);

  return (
    <section id="contact" className="scroll-mt-24 w-full px-4 md:px-8 pb-14 md:pb-20">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20background%20for%20a%20medical%20ecosystem%20call%20to%20action%2C%20flowing%20crimson%20and%20gold%20ink%20brush%20textures%20blending%20with%20subtle%20digital%20network%20lines%20and%20herbal%20leaf%20silhouettes%2C%20deep%20warm%20red%20and%20charcoal%20tones%2C%20cinematic%20soft%20lighting%2C%20elegant%20minimal%20artistic%20composition&width=1920&height=700&seq=cta-tcm-2026&orientation=landscape"
            alt="生态合作"
            title="中西医结合智慧生态平台 - 生态合作"
            className="w-full h-full absolute inset-0 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/50"></div>
          <div className="relative px-6 md:px-14 py-14 md:py-20 text-center md:text-left">
            <div className="max-w-2xl md:mx-0 mx-auto">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur text-background-50 text-xs md:text-sm mb-5">
                <i className="ri-government-line text-secondary-300"></i>
                机构入驻 · 协同共建
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug text-balance mb-4">
                诚邀医院、基层机构与产业伙伴加入生态
              </h2>
              <p className="text-sm md:text-base text-background-100/85 leading-relaxed mb-8">
                共建课程、活动、视频与医师资源体系，共享中西医结合智慧生态，让优质健康服务触达更多人群。
              </p>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 justify-center md:justify-start">
                <button
                  type="button"
                  onClick={() => setCooperationOpen(true)}
                  className="inline-flex items-center justify-center gap-2 bg-secondary-500 hover:bg-secondary-600 text-foreground-950 font-medium px-7 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-hand-heart-line"></i>
                  申请生态合作
                </button>
                <a
                  href="#intro"
                  className="inline-flex items-center justify-center gap-2 border border-background-50/40 text-background-50 hover:bg-background-50/10 font-medium px-7 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  了解平台
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <QuickEntryFormModal
        type={cooperationOpen ? 'cooperation' : null}
        onClose={() => setCooperationOpen(false)}
      />
    </section>
  );
}